import script from "./DCEditStreak.vue?vue&type=script&setup=true&lang=ts"
export * from "./DCEditStreak.vue?vue&type=script&setup=true&lang=ts"

import "./DCEditStreak.vue?vue&type=style&index=0&id=c6fe739e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6fe739e"]])

export default __exports__